export const BTN_STYLES = {
  normal: "bg-green-500 text-black border-transparent hover:no-underline hover:shadow cursor-pointer",
  border: "bg-transparent text-black border border-black hover:no-underline hover:shadow cursor-pointer",
  text: "bg-transparent text-black border-transparent hover:shadow-none hover:underline hover:shadow cursor-pointer",
  "text-red": "bg-transparent text-red-500 border-transparent hover:shadow-none hover:underline hover:shadow cursor-pointer",
  red: "bg-red-100 text-black border-transparent hover:no-underline hover:shadow cursor-pointer",
  white: "bg-white text-black border-transparent hover:no-underline hover:shadow cursor-pointer"
};

export const BTN_DISABLED_STYLES = {
  normal: "bg-gray-200 text-gray-500 border-transparent hover:no-underline pointer-events-none cursor-auto",
  border: "bg-transparent text-gray-200 border border-gray-200 hover:no-underline pointer-events-none cursor-auto",
  text: "bg-transparent text-gray-200 border-transparent hover:shadow-none hover:underline pointer-events-none cursor-auto",
  "text-red": "bg-transparent text-red-200 border-transparent hover:shadow-none hover:underline pointer-events-none cursor-auto",
  red: "bg-red-100 text-black border-transparent hover:no-underline pointer-events-none cursor-auto",
  white: "bg-white text-black border-transparent hover:no-underline pointer-events-none cursor-auto"
};

export const DEFAULT_STYLE: string = "btn rounded-full inline-flex justify-center items-center border font-medium focus:outline-none whitespace-nowrap";

export const DEFAULT_SIZE: string = "h-[54px] text-[16px] leading-[24px] px-6";
export const SMALL_SIZE: string = "h-[34px] text-[14px] leading-[22px] px-3";
export const SMALLER_SIZE: string = "h-[30px] text-[12px] leading-[20px] px-3";

